module.exports = __webpack_public_path__ + "static/sb_mod_pack-5d3a262fa33ce6f1ac9954a7c8314050.png";